import { Ruler } from "lucide-react";
import ResourcePage from "@/components/ResourcePage";
import { makeAdapter } from "@/lib/supabaseAdapter";

const adapter = makeAdapter({ table: "growth_measurements", filterColumn: "profile_id" });

export default function GrowthTracker() {
  return (
    <ResourcePage
      config={{
        adapter,
        filterBy: "profile_id",
        eyebrow: "Milestones",
        title: "Growth",
        description: "Log height, weight, and head circumference over time.",
        icon: Ruler,
        accent: "bg-teal-light text-primary",
        addLabel: "Add measurement",
        testIdPrefix: "growth",
        blank: () => ({
          profile_id: "",
          measurement_date: "",
          height_cm: "",
          weight_kg: "",
          head_circumference_cm: "",
          notes: "",
        }),
        transform: (f, { profile }) => ({
          profile_id: f.profile_id,
          profile_name: profile?.name || null,
          measurement_date: f.measurement_date,
          height_cm: f.height_cm ? Number(f.height_cm) : null,
          weight_kg: f.weight_kg ? Number(f.weight_kg) : null,
          head_circumference_cm: f.head_circumference_cm ? Number(f.head_circumference_cm) : null,
          notes: f.notes || null,
        }),
        fields: [
          { key: "measurement_date", label: "Measured on", type: "date", required: true, span: 2 },
          { key: "height_cm", label: "Height (cm)", type: "number", step: "0.1" },
          { key: "weight_kg", label: "Weight (kg)", type: "number", step: "0.01" },
          { key: "head_circumference_cm", label: "Head (cm)", type: "number", step: "0.1", span: 2 },
          { key: "notes", label: "Notes", type: "textarea" },
        ],
        render: (g) => (
          <div>
            <div className="font-heading text-base font-bold leading-tight">
              {g.measurement_date}
            </div>
            <div className="mt-3 grid grid-cols-3 gap-2">
              {g.height_cm != null && (
                <Stat label="Height" value={`${g.height_cm} cm`} />
              )}
              {g.weight_kg != null && (
                <Stat label="Weight" value={`${g.weight_kg} kg`} />
              )}
              {g.head_circumference_cm != null && (
                <Stat label="Head" value={`${g.head_circumference_cm} cm`} />
              )}
            </div>
            {g.notes && (
              <div className="mt-3 text-xs text-muted-foreground">{g.notes}</div>
            )}
          </div>
        ),
      }}
    />
  );
}

const Stat = ({ label, value }) => (
  <div className="rounded-lg bg-secondary/40 px-2.5 py-2 text-center">
    <div className="text-[10px] uppercase tracking-wider text-muted-foreground">{label}</div>
    <div className="font-heading text-sm font-bold">{value}</div>
  </div>
);
